import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import SnackBarComponent from "../Helpers/SnackBarComponent";
import axiosRequest from "../../api/axios";
import TableModal from "./TableModal";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableHeader, StyledTableRow } from "../Helpers/TableHeader";
import TableRow from "@mui/material/TableRow";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";

const headCells = [
  {
    id: "name",
    label: "BUHead Name",
    align: "left",
    padding: "0px",
  },
  {
    id: "quarter",
    label: "Quarter",
    align: "left",
    padding: "0px",
  },
  {
    id: "teamcode",
    label: "Teamcode",
    align: "left",
    padding: "0px",
  },
  {
    id: "view",
    label: "View",
    align: "left",
    padding: "0px",
  },
  {
    id: "Action",
    label: "Action",
    align: "left",
    padding: "0px",
  },
];

const useStyles = makeStyles((theme) => ({
  container: {
    maxHeight: 1000,
  },
  fs12: {
    fontSize: "12px",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.secondary.main,
    // color: theme.palette.common.white,
    paddingLeft: 10,
    paddingRight: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

export default function CommercialHeadTable() {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const email = localStorage.getItem("email");
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [showModal, setshowModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const api_headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("Token"),
  };
  const handleClick = (row) => {
    setData(row.tabledata);
    setshowModal(true);
  };

  const handleClose = () => {
    setOpensb(false);
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };

  const getData = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/getcommercialhead/",
      method: "POST",
      headers: api_headers,
      data: {
        reports_to: email,
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        setRows(data?.data?.data);
        handleSnackBar("data loaded successfully", "success");
        setLoader(false);
      } else {
        handleSnackBar("no data found", "error");
        setLoader(false);
      }
    });
  };
  const [approved, setapproved] = React.useState(false);
  const [loaderApprove, setloaderApprove] = React.useState(false);
  const [loaderdisApprove, setloaderdisApprove] = React.useState(false);
  const [loaderID, setloaderID] = React.useState(false);
  const [loaderIDdis, setloaderIDdis] = React.useState(false);
  const handleApprove = async (row) => {
    setloaderApprove(true);
    setloaderID(row.id)
    await axiosRequest({
      url: "bu_head_app/commercialheadapprove/",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: row.teamcode,
        email:row.name,
        id: row.id,
        // teamcode: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        setloaderApprove(false);
        setapproved(true);
        handleSnackBar("Approved the budgets", "success");
      } else {
        setapproved(false);
        setloaderApprove(false);
        handleSnackBar("no data found", "error");
      }
    });
  };

  const handleDisApprove = async (row) => {
    setloaderdisApprove(true);
    setloaderIDdis(row.id)
    await axiosRequest({
      url: "bu_head_app/commercialheaddisapprove/",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: row.teamcode,
        year: localStorage.getItem("year"),
        email:row.name,
        quarter: localStorage.getItem("quarter"),
        id: row.id,
      },
    }).then((data) => {
      if (data.status === 200) {
        setloaderdisApprove(false);
        handleSnackBar("disapproved the budgets", "success");
      } else {
        setloaderdisApprove(false);
        handleSnackBar("no data found", "error");
      }
    });
  };

  React.useEffect(() => {
    getData();
  }, []);

  return (
    <React.Fragment>
      {loader === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100vh",
          }}
        >
          <CircularProgress color="inherit" display={loader.toString()} />
        </div>
      ) : (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TableContainer
            className={classes.container}
            style={{ marginTop: 40, marginLeft: 40, marginBottom: 40 }}
          >
            <Table stickyHeader style={{ width: "820px", height: "auto" }}>
              <TableHeader headers={headCells} />
              <TableBody>
                {rows.map((row, index) => {
                  return (
                    <TableRow tabIndex={-1} key={index}>
                      <StyledTableCell className={classes.fs12} align="left">
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        {row.quarter}
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        {row.teamcode}
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        <button
                          className="save-btn"
                          onClick={() => handleClick(row)}
                        >
                          view
                        </button>
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        <button
                        disabled={row.status == "success"?true:false}
                          className="submit-btn"
                          onClick={() => handleApprove(row)}
                          style={{ backgroundColor: row.status == "success" ? "#e5e5e5" : "" ,color:"green",fontWeight:"bold"}}
                        >
                          {loaderApprove === true && loaderID == row.id? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CircularProgress
                                size="1rem"
                                color="inherit"
                                display={loaderApprove}
                              />
                            </div>
                          ) : (
                            <span> {row.status == "success" ? "Approved" : "Approve"}</span>
                          )}
                        </button>
                        <button
                          className="submit-btn"
                          style={{ marginLeft: 20 }}
                          onClick={() => handleDisApprove(row)}
                          disabled={row.status == "success"?true:false}
                        >
                           {loaderdisApprove === true && loaderIDdis == row.id ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CircularProgress
                                size="1rem"
                                color="inherit"
                                display={loaderdisApprove}
                              />
                            </div>
                          ) : (
                            <span> Dispprove</span>
                          )}
                        </button>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
      />
      <TableModal open={showModal} data={data} setshowModal={setshowModal} />
    </React.Fragment>
  );
}
